export interface VerticalTabListModel {
  name: string;
  key: string;
};
